import { Box, Button, DialogActions, Typography } from '@mui/material';
import React from 'react';
import { Manager } from '../../models/manager';
import { Talent } from '../../models/talent';
import DefaultModal from './DefaultModal';

interface Props {
  modalData: { open: boolean; user: Manager[] | Talent[] };
  closeModal: () => void;
  confirmModal: () => void;
}

const CredentialsModal = (props: Props): JSX.Element => {
  return (
    <DefaultModal open={props.modalData.open} handleClose={props.closeModal}>
      <Box sx={{ px: 6 }}>
        <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
          Resend Login Credentials?
        </Typography>

        <Typography textAlign="center" mb={1}>
          Your about to resend login credentials to:
        </Typography>
        {props.modalData.user.map((user) => (
          <Typography
            key={user.id}
            variant="subtitle1"
            textAlign="center"
            mb={1}
          >
            <strong>{`${user.firstName} ${user.lastName}`}</strong>
          </Typography>
        ))}
      </Box>
      <DialogActions sx={{ justifyContent: 'center', py: 3 }}>
        <Button variant="outlined" onClick={props.closeModal}>
          Cancel
        </Button>
        <Button onClick={props.confirmModal}>Yes, Send Credentials</Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default CredentialsModal;
